import { Button, Card, Collapse, Divider, message, Popconfirm } from 'antd';
import React, { FC, useCallback, useState } from 'react';
import { FlexibleImageAvatar } from '../flexible-image-avatar/FlexibleImageAvatar';
import CollapsePanel from 'antd/lib/collapse/CollapsePanel';
import {
	compareStrings,
	getCurrency,
	nullSafeGet,
	nullSafeGetOrElse,
	recordHasContractorId,
} from '../../utils/DataAccessUtils';
import { connect } from 'react-redux';
import { AWARD_STATUSES } from '../../constants/BidderStatuses';
import { CheckOutlined } from '@ant-design/icons';
import { currencyFormatter } from '../../utils/DataFormatterUtils';
import FileUploader from '../file_uploader/FileUploader';
import { withRouter } from 'react-router';
import { withUserType } from '../withUserType';
import { SupplierFacilityName } from '../name_component/supplierFacility/supplierFacilityNameComponent';
import { UserName } from '../name_component/user/UserNameComponent';
import FormDots from '../common/FormDots';
import FormDashes from '../FormDashes';
import { CustomCurrencyDisplay } from '../custom_currency_display/CustomCurrencyDisplay';
import DateTimeHover from '../date_time_component/DateTime';
import { userTimeZone } from '../../utils/DataConstants';

const BidderCard: FC<any> = ({
	userType,
	bidder,
	bidderAwarded,
	requestForProposal,
	awardUpdating,
	handleAwardStatusChange,
	lowestBidderSupplierFacilityId,
	size = 'default',
	showSupplierInfo = true,
	updateQuote,
	currentUser,
}) => {
	const width = size === 'large' ? '100%' : '320px';
	const currency = getCurrency({ supplierFacility: nullSafeGet('supplierFacility', bidder) });
	return (
		<Card
			key={bidder.supplierFacilityId}
			className="bidComparisonTable"
			style={{ minWidth: '320px', width }}
			bodyStyle={{ padding: 0 }}
		>
			{showSupplierInfo ? (
				<div>
					<div style={{ padding: 16 }}>
						<SupplierFacilityName
							facility={nullSafeGet('supplierFacility', bidder)}
							mode={'card'}
							placement={'top'}
							allowHover={false}
							size={'large'}
							subTitle={null}
						/>
					</div>
					<Divider
						style={{
							marginTop: 8,
							marginBottom: 0,
							marginLeft: 0,
							marginRight: 0,
							borderTopColor: `#F0F0F0`,
						}}
					/>
				</div>
			) : null}

			<div className="">
				<div className="">
					<Collapse ghost>
						<CollapsePanel header="Scope" key="1">
							<div
								className="mb-4 flex flex-col overflow-auto"
								dangerouslySetInnerHTML={{
									__html: nullSafeGetOrElse('proposal.scope', bidder, '--'),
								}}
							/>
						</CollapsePanel>
						<Divider
							style={{
								marginTop: 0,
								marginBottom: 0,
								marginLeft: 12,
								marginRight: 12,
								borderTopColor: `#F0F0F0`,
							}}
						/>
					</Collapse>
					<Collapse ghost>
						<CollapsePanel
							header={`Attachments ${
								nullSafeGet('proposal.attachments.length', bidder) > 0
									? `(${nullSafeGet('proposal.attachments.length', bidder)})`
									: ''
							}`}
							key="1"
							collapsible={nullSafeGet('proposal.attachments.0', bidder) ? 'header' : 'disabled'}
						>
							<FileUploader
								roleType={userType}
								defaultFileList={nullSafeGetOrElse('proposal.attachments', bidder, [])}
								uploaderType={'readOnly'}
							/>
						</CollapsePanel>
					</Collapse>
					<div className="sectionTextWrapperAroundButtons">
						<Divider style={{ marginTop: 0, marginBottom: 0, borderTopColor: `#F0F0F0` }} />
						<div className="sectionTextWrapperWithBid">
							<div
								style={{
									display: 'flex',
									flexDirection: 'column',
									justifyContent: 'center',
									height: '100%',
								}}
							>
								{compareStrings(
									nullSafeGet('awardStatus', bidder),
									AWARD_STATUSES.AssignedSupplier
								) ? (
									<div className="bidSummary_assignedSupplier">Assigned Supplier</div>
								) : null}
								{bidder.supplierFacilityId === lowestBidderSupplierFacilityId ? (
									<div className="bidSummary_lowBidder">
										<span>Apparent Low Bidder</span>
									</div>
								) : null}
								<h5 style={{ marginBottom: 0 }}>
									<CustomCurrencyDisplay
										value={nullSafeGet('proposal.totalAfterTax', bidder)}
										currency={currency}
										currencyStyle={{ fontSize: 16 }}
									/>
								</h5>
							</div>
							<div>
								{compareStrings(nullSafeGet('awardStatus', bidder), AWARD_STATUSES.Awarded) ? (
									<div style={{ fontSize: 16 }}>Awarded</div>
								) : compareStrings(nullSafeGet('awardStatus', bidder), AWARD_STATUSES.Declined) ? (
									<div style={{ fontSize: 16 }}>Declined</div>
								) : bidderAwarded ? (
									<Popconfirm
										onConfirm={() =>
											handleAwardStatusChange(
												requestForProposal.id,
												bidder.supplierFacilityId,
												'declined'
											)
										}
										placement="topLeft"
										title="Send declined note to the supplier?"
										okText="Confirm decline"
										cancelText="Cancel"
									>
										<Button loading={awardUpdating} type="primary">
											Decline
										</Button>
									</Popconfirm>
								) : (
									<div className="flex flex-col gap-2">
										<Popconfirm
											onConfirm={() =>
												handleAwardStatusChange(
													requestForProposal.id,
													bidder.supplierFacilityId,
													'awarded'
												)
											}
											placement="topLeft"
											title="Confirm award and send award note to the supplier?"
											okText="Confirm award"
											cancelText="Cancel"
										>
											<Button loading={awardUpdating} type="primary">
												Award
											</Button>
										</Popconfirm>
										<Popconfirm
											onConfirm={() =>
												handleAwardStatusChange(
													requestForProposal.id,
													bidder.supplierFacilityId,
													'declined'
												)
											}
											placement="topLeft"
											title="Are you sure, you want to decline?"
											okText="Confirm decline"
											cancelText="Cancel"
										>
											<Button
												loading={awardUpdating}
												type="ghost"
												style={{ backgroundColor: 'white' }}
											>
												Decline
											</Button>
										</Popconfirm>
									</div>
								)}
							</div>
						</div>
						<Divider style={{ marginTop: 0, marginBottom: 4 }} />
					</div>
				</div>
			</div>
			{[
				{ key: 'Incurred Cost', value: 'incurredCostTotalBeforeTax' },
				{ key: 'Labor', value: 'laborTotalBeforeTax' },
				{ key: 'Materials', value: 'materialTotalBeforeTax' },
				{ key: 'Travel', value: 'travelTotalBeforeTax' },
				{ key: 'Freight', value: 'freightTotalBeforeTax' },
				{ key: 'Miscellaneous', value: 'miscTotalBeforeTax' },
				{ key: 'Total Before Tax', value: 'totalBeforeTax' },
				{ key: 'Tax', value: 'tax' },
				{ key: 'Grand Total', value: 'totalAfterTax' },
			].map((category) => (
				<div className="py-3" key={category.key}>
					<div>
						<div
							style={{
								display: 'flex',
								alignItems: 'center',
								margin: '0 16px',
								fontSize: 13,
								justifyContent: 'space-between',
							}}
						>
							<div className="sectionTextMain font-semibold">{category.key}</div>
							<FormDashes style={{ color: '#D9D9D9' }} />
							<div className="sectionTextSecondary">
								<CustomCurrencyDisplay
									value={nullSafeGet(`proposal.${category.value}`, bidder)}
									currency={currency}
								/>
							</div>
						</div>
					</div>
				</div>
			))}
			<div className={'mb-3 mt-4 flex justify-center'}>
				<span style={{ fontSize: 11 }}>
					Updated by{' '}
					<UserName
						mode={'inline'}
						contact={nullSafeGet('createdByContact', requestForProposal)}
						position={'bottom'}
					/>{' '}
					<DateTimeHover
						timestamp={nullSafeGet('createdAt', requestForProposal)}
						timeZone={userTimeZone}
					/>
				</span>
			</div>
		</Card>
	);
};

const mapStateToProps = (state) => ({
	currentUser: state.session.currentUser,
});
const mapDispatchToProps = (dispatch, ownProps) => ({});

export default withRouter<any, any>(
	withUserType(connect(mapStateToProps, mapDispatchToProps)(BidderCard))
);
